<template id="app">
  <div>
    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand to="/">
          <img src="./assets/logo.png" alt="CKLMPRONO">
          CKLM-pronos
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/pronostics" v-if="!auth.user">Espace VIP</b-nav-item>
            <b-nav-item to="/abonnement" v-if="!auth.user">Nos abonnements</b-nav-item>
            <b-nav-item to="/pronostics" v-if="auth.user">Nos pronostics</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto" v-if="auth.user">
            <b-img class="d-none d-lg-block" v-if="auth.user.photoURL" :src="auth.user.photoURL" width="40" height="40" rounded="circle"></b-img>
            <b-img class="d-none d-lg-block" v-if="!auth.user.photoURL" src="https://bestresources.com.au/wp-content/uploads/2017/05/avatar-icon-1.png" width="40" height="40" rounded="circle"></b-img>
            <b-nav-item-dropdown :text="auth.user.name ? auth.user.name : 'Mon compte'" right>
              <b-dropdown-item to="/mon-compte">Mon compte</b-dropdown-item>
              <b-dropdown-item to="/dashboard" v-if="auth.user.admin" >Tableau de bord</b-dropdown-item>
              <b-dropdown-item to="/users" v-if="auth.user.admin" >Utilisateurs</b-dropdown-item>
              <b-dropdown-item v-on:click="logout()">Deconnexion</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto" v-if="!auth.user">
            <b-nav-item to="/connexion">Se connecter</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div class="container-fluid">
      <router-view/>
      <footer class="static-bottom" style="margin-top: 5em;">
        <div class="row justify-content-md-center">
          <div class="col-12 text-center bg-dark">
            <span class="text-muted font-italic">
              Jouer comporte des risques endettement, isolement, dépendance.<br/>
              Pour être aidé, appelez le 09.74.75.13.13 (appel non surtaxé)<br/>
              v1.3 - <a href="mailto:cklmprono@gmail.com">Contact</a>
            </span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase.js'
import { auth } from '@/firebase.js'

export default {
  data: () => ({ error: null, auth: auth }),
  methods: {
    logout: function () {
      firebase.auth().signOut().then(() => this.$router.replace('/')).catch((error) => {
        alert(error.message);
      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  background: #212529 !important;
  color: white !important;
}
/*
a:hover {
  color: #eac136 !important;
}
*/
.button {
  cursor: pointer;
}
</style>